import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import {
  Card,
  Pagination,
  Button,
  ConfigProvider,
  Input,
  Select,
  Form,
  Modal,
  Col,
  message,
} from "antd";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { useHistory } from "react-router-dom";
import "./index.scss";
import { getCurrentUser, getDictOne } from "utils/storage";
import zh_CN from "antd/es/locale/zh_CN";
import { getStatus } from "@/utils/methods";
import ApproveModal from "@/components/ApproveModal";
import { Loading } from "element-react";
const { TextArea } = Input;
const { Search } = Input;
const { Option } = Select;
function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}
export default function ServiceApplication(props) {
  const imageUrl =
    "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg";
  const [list, setList] = useState([
    {
      label: "申请人姓名",
      name: "lgsjjx",
      value: "",
      type: "input",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "身份证号码",
      name: "lgsjjx",
      value: "",
      type: "input",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "创业行业",
      name: "lgsjjx",
      value: "",
      type: "select",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "创业地点",
      name: "lgsjjx",
      value: "",
      type: "input",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "企业地址",
      name: "lgsjjx",
      value: "",
      type: "input",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "联系方式",
      name: "lgsjjx",
      value: "",
      type: "input",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "创业项目资金支持",
      name: "lgsjjx",
      value: "",
      type: "input",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "创业项目贷款支持",
      name: "lgsjjx",
      value: "",
      type: "input",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "创业行业",
      name: "lgsjjx",
      value: "",
      type: "select",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "创业项目详情",
      name: "lgsjjx",
      value: "",
      type: "TextArea",
      require: true,
      placeholder: "请选择奖励奖项",
    },
    {
      label: "企业简介",
      name: "lgsjjx",
      value: "",
      type: "TextArea",
      require: true,
      placeholder: "请选择奖励奖项",
    },
  ]);
  const { searchValue, select2 } = props;
  const [currentPage, setCurrentPage] = useState(1); //当前页数
  const [total, setTotal] = useState(0);
  const [ids, setIds] = useState("");
  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectValue2, setSelectValue2] = useState("");
  const handlePage = (page, pageSize) => {
    setCurrentPage(page);
  };
  const modalRef = useRef([]);
  const history = useHistory();
  const dictList = getDictOne("industry_code");
  const handleJobDetail = (id) => {
    history.push(`entrepreneurship/assistItem/${id}`);
  };
  // console.log("searchValuesearchValuesearchValue", searchValue);
  // console.log("dictdict", dictList);

  const showModal = useCallback((e, id) => {
    message.config({
      top: 50,
      duration: 1,
      maxCount: 1,
    });
    // console.log("eeeeeeeeeeeeeeeee", e);
    e.stopPropagation();
    e.preventDefault();
    let userToken = getCurrentUser();
    // console.info(userToken);
    if (!userToken) {
      message.error("还未登录，请先登录后再申请！");
      history.push("/login");
    } else {
      if (getCurrentUser().user_type != "2") {
        message.warn("非退役军人不可申请!");
        return;
      }
      getStatus().then((res) => {
        if (res === false) {
          modalRef.current.showModal();
          return;
        }
        setIds(id);
        e.stopPropagation();
        setModalVisible(true);
      });
    }
  });
  const handleOk = () => {
    Http.post(Request.applyFor(), { servicesId: ids }, (obj) => {
      if (obj.code == 200) {
        message.success("申请成功", 2);
      } else {
        message.info(obj.msg || "申请失败", 2);
      }
      // console.log("objobj", obj);
    });
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleChange = () => {};

  const renderBasicInfo = () => {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return list.map((item, index) => {
      if (item.type == "input") {
        return (
          <Col span={24}>
            <Form.Item {...formItemLayout} label={item.label}>
              <Input placeholder={"请输入姓名"} />
            </Form.Item>
          </Col>
        );
      } else if (item.type == "TextArea") {
        return (
          <Col span={24}>
            <Form.Item {...formItemLayout} label={item.label}>
              <TextArea placeholder={"请输入姓名"} />
            </Form.Item>
          </Col>
        );
      } else if (item.type == "select") {
        return (
          <Col span={24}>
            <Form.Item {...formItemLayout} label={item.label}>
              <Select defaultValue="lucy" onChange={handleChange}>
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
                <Option value="disabled" disabled>
                  Disabled
                </Option>
                <Option value="Yiminghe">yiminghe</Option>
              </Select>
            </Form.Item>
          </Col>
        );
      }
    });
  };

  // const onSearch=props.searchValue;
  const initiaList = useCallback(() => {
    let select2 =
      props.select2 === undefined
        ? ""
        : props.select2 == 0
        ? ""
        : props.select2;
    let params = {
      size: 10,
      current: currentPage,
      likeParam: props.searchValue,
      servicesIndustry: select2,
    };

    Http.get(Request.serveList(), { ...params }, (obj) => {
      setData(obj.data?.records || []);
      setTotal(obj.data?.total || []);
    });
  });

  useEffect(() => {
    initiaList();
  }, [ currentPage, searchValue, select2, selectValue2]);

  return (
    <div className={"createAssist_app"}>
      <div className="getjob_major_thin">
        {data.map((item, index) => {
          return (
            <div
              onClick={() => {
                handleJobDetail(item.id);
              }}
              className="getjob_center"
            >
              <div>
                <i></i>

                <span style={{ fontWeight: "900" }}>
                  {dictList &&
                    dictList.map((dict) => {
                      if (item.servicesIndustry == dict.dictKey) {
                        return dict.dictValue;
                      }
                    })}
                </span>
              </div>
              <div>
                <div>
                  <img
                    style={{ width: 145, height: 82 }}
                    src={item.coverImage}
                    alt=""
                  />
                </div>
                <div>
                  <ul>
                    <li>
                      <span>{item.servicesName}</span>
                    </li>
                    <li>{item.servicesIntroduce}</li>
                    <li>{item.releaseTime}</li>
                  </ul>
                </div>
                {/* <Button onClick={(e)=>{showModal(e,item.id)}} style={{position:'absolute',right:20}} className="getjob_center_buttom" type="primary">{"申请创业服务"}</Button> */}
              </div>
            </div>
          );
        })}
      </div>
      <Modal
        title="创业服务申请"
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {/* {renderBasicInfo()} */}
        <span style={{ fontSize: 20 }}>确定申请创业服务吗</span>
      </Modal>
      <ConfigProvider locale={zh_CN}>
        <Pagination
          total={total}
          itemRender={itemRender}
          showQuickJumper={{
            goButton: <Button className={"pagination_jump"}>确定</Button>,
          }}
          showTotal={(total) => `共 ${total} 条`}
          onChange={handlePage}
          showSizeChanger={false}
          current={currentPage}
          defaultPageSize={10}
          style={{
            marginTop: 14,
            paddingRight: 24,
            display: "flex",
            justifyContent: "flex-end",
          }}
        />
      </ConfigProvider>
      <ApproveModal ref={modalRef} />
    </div>
  );
}
